import React, { forwardRef } from 'react';

import type { MenuItemProps } from '@mui/material';
import { ListItemIcon, MenuItem } from '@mui/material';
import { CheckMarkIcon } from 'src/components/icons/CheckMarkIcon';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  listIcon: {
    minWidth: 32,
  },
  root: {
    fontSize: 14,
  },
}));

// Note: We need to omit the button prop because when it's included, TS throws an error that the types are inconsistent.
interface CheckMarkMenuItemProps extends Omit<MenuItemProps, 'button'> {
  children: React.ReactNode;
  selected?: boolean;
  showCheckMark?: boolean;
}

/**
 * Note: Make sure to spread ...rest on the MenuItem as we expect props to be passed down for the component to work properly.
 */
export const CheckMarkMenuItem = forwardRef(function CheckMarkMenuItem(
  props: CheckMarkMenuItemProps,
  ref: React.Ref<HTMLLIElement>
): JSX.Element {
  const { classes } = useStyles();
  const { children, selected, showCheckMark, ...rest } = props;
  const showCheck = showCheckMark ? showCheckMark : selected;

  return (
    <MenuItem
      ref={ref}
      dense
      classes={{
        root: classes.root,
      }}
      selected={selected}
      {...rest}
    >
      {showCheck ? (
        <ListItemIcon className={classes.listIcon}>
          <CheckMarkIcon />
        </ListItemIcon>
      ) : (
        <ListItemIcon className={classes.listIcon}>
          <div />
        </ListItemIcon>
      )}
      {children}
    </MenuItem>
  );
});
